import { Box, Text } from '@chakra-ui/layout'
import { Modal, Row, Col } from 'antd'
import useSaveFeriados from 'core/features/feriados/hooks/useSaveFeriados'
import { useForm } from 'react-hook-form'
import FooterModal from 'ui/components/Button/FooterModal'
import Field from 'ui/components/Input/Field'
import moment from 'moment'
import { useEffect } from 'react'

interface ModalFeriadosProps {
  isOpen: boolean
  tenantId: string
  onClose: () => any
  loadingSave?: boolean
  onSaved: any
  defaultValue?: any
}

function ModalFeriados({
  isOpen,
  tenantId,
  onClose,
  onSaved,
  defaultValue
}: ModalFeriadosProps) {
  const { control, formState, reset, handleSubmit } = useForm<any>({
    reValidateMode: 'onChange',
    mode: 'all'
  })

  const { mutate: handleSave, isLoading } = useSaveFeriados(tenantId)

  useEffect(() => {
    if (defaultValue) {
      const data = {
        nome: defaultValue.nome,
        data: `${defaultValue.ano}-${defaultValue.mes}-${defaultValue.dia}`
      }

      reset(data)
    }
  }, [defaultValue, reset])

  const onSubmit = (data: any) => {
    const dataMoment = moment(data.data)

    handleSave(
      {
        id: defaultValue?.id,
        nome: data.nome,
        ano: dataMoment.format('YYYY'),
        mes: dataMoment.format('MM'),
        dia: dataMoment.format('DD')
      },
      {
        onSuccess: () => {
          onSaved()
        }
      }
    )
  }

  return (
    <Modal
      width="500px"
      footer={
        <FooterModal
          isDisabled={!formState.isValid || isLoading}
          isLoadingSave={isLoading}
          onSubmit={handleSubmit(onSubmit)}
          onClose={onClose}
          showRegisterAnother={false}
          primaryButtonText={defaultValue ? 'Editar' : 'Salvar'}
        />
      }
      visible={isOpen}
      onCancel={onClose}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box>
          <Title text="Cadastrar feriado municipal" />

          <Box as={Row} gutter={16}>
            <Box as={Col} xs={12}>
              <Field
                inputProps={{
                  type: 'date'
                }}
                label="Data"
                control={control}
                name="data"
                rules={{
                  required: true
                }}
              />
            </Box>

            <Box as={Col} xs={12}>
              <Field
                label="Descrição"
                control={control}
                name="nome"
                rules={{
                  required: true
                }}
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Modal>
  )
}

const Title = ({ text }: { text: string }) => (
  <Text as="h3" fontSize={18} fontWeight="bold" mb={4}>
    {text}
  </Text>
)

export default ModalFeriados
